var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThickRightIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_5988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 71.8423C55.1061 71.8423 71 55.9484 71 36.3423C71 16.7362 55.1061 0.842285 35.5 0.842285C15.8939 0.842285 0 16.7362 0 36.3423C0 55.9484 15.8939 71.8423 35.5 71.8423Z",
    fill: "#3986E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 51.773L44.4296 69.8423C59.6935 65.8515 71 52.2164 71 35.9208C71 35.5882 71 35.2557 71 34.9231L56.5276 21.8423L26 51.773Z",
    fill: "#0B59B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8079 44.4988C38.3974 46.0814 38.3974 48.7945 36.8079 50.3771L33.5153 53.6553C31.9258 55.2379 29.2009 55.2379 27.6114 53.6553L13.1921 39.1858C11.6026 37.6032 11.6026 34.8901 13.1921 33.3075L16.4847 30.0292C18.0742 28.4466 20.7991 28.4466 22.3886 30.0292L36.8079 44.4988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7702 20.0199C50.3354 18.4498 53.0186 18.4498 54.5838 20.0199L57.8261 23.2722C59.3913 24.8423 59.3913 27.5339 57.8261 29.104L33.2298 53.6647C31.6646 55.2348 28.9814 55.2348 27.4161 53.6647L24.1739 50.4124C22.6087 48.8423 22.6087 46.1507 24.1739 44.5806L48.7702 20.0199Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_5988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(0 0.842285)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickRightIcn);
export default __webpack_public_path__ + "static/media/thick-right-icn.5ae1751c74538b56bb7f7b2dbfcf8488.svg";
export { ForwardRef as ReactComponent };